import { AppState } from "../../../redux-configuration/AppState";
import { InstantHeader } from "../../domain/entites/instantHeader";

export const loadingInstantsAgendaSelector = (state: AppState): boolean => state.instants.agenda.loading
export const errorLoadingInstantsAgendaSelector = (state: AppState): string | undefined => state.instants.agenda.error
export const instantsAgendaSelector = (state: AppState): InstantHeader[] => state.instants.agenda.instants
